import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper" }

import ScoutsLogo from "@/components/Common/ScoutsLogo.vue";
import LoadingSpin from "@/components/Common/LoadingSpin.vue";
import ContentHolder from "@/components/RegistrationPage/MobileVersion/ContentHolder.vue";
import {default as templateStore} from "@/store";
import BonusDescriptionModal from "@/components/RegistrationPage/MobileVersion/BonusDescriptionModal.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'RegistrationPageMobileVersion',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ScoutsLogo),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_unref(templateStore).state.passes.length === 0)
            ? (_openBlock(), _createBlock(LoadingSpin, { key: 0 }))
            : (_openBlock(), _createBlock(ContentHolder, { key: 1 }))
        ]),
        _: 1
      })
    ]),
    _createVNode(BonusDescriptionModal)
  ]))
}
}

})